import { DrawingFixtureDto } from "./drawing-fixture.dto";

export class DrawClubWCPlayoffRequest {
    fixtures: DrawingFixtureDto[];
    stage: number;
    md: number;
}